import * as React from 'react';
import * as queryString from 'query-string';

import * as sessionUtils from 'login-utils/sessionUtils';
import * as trackingAPI from 'login-apis/trackingAPI';
import { utils } from 'ui-common';
import { WindowWrapper } from 'login-utils/globalWrappers';
import MobileWatcher from '../MobileWatcher';
import NonProdWarningBar from '../NotificationBar/NonProdWarningBar';
const { performanceUtils } = utils;

type LoginWrapperProps = ReactRouter.RouteComponentProps<{}, {}>;

/*
 * This component is a wrapper around the entire app (but below the error boundary)
 * that is used by pingdom to monitor uptime.
 */
export default class LoginWrapper extends React.PureComponent<LoginWrapperProps> {
  componentDidMount() {
    const { location } = this.props;
    sessionUtils.saveQueryToSession(queryString.parse(location.search));

    if (WindowWrapper.timePerformance) {
      trackingAPI.logEvent('performance.appLoad', { duration: performance.now() });
      performanceUtils.setupPerformanceMetricListeners(trackingAPI);
      WindowWrapper.timePerformance = false;
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div id="pingdom-transaction-check">
        <NonProdWarningBar />
        <MobileWatcher />

        {children}
      </div>
    );
  }
}
